import React, { FocusEventHandler, ReactNode } from 'react';
import { Field } from 'react-final-form';
import { TextInput } from '~common/components/form/text-input.component';

interface Props {
  name?: string;
  label?: string;
  autocomplete?: string;
  startAdornment?: ReactNode;
  multiline?: boolean;
  disabled?: boolean;
  autofocus?: boolean;
  onFocus?: FocusEventHandler<HTMLInputElement>;
}

export const TextField: React.FunctionComponent<Props> = ({
  name,
  label,
  autocomplete,
  startAdornment,
  multiline,
  disabled,
  autofocus,
  onFocus,
  ...rest
}) => {
  return (
    <Field
      label={label}
      name={name}
      onFocus={onFocus}
      render={(renderProps): ReactNode => (
        <TextInput
          fullWidth
          multiline={multiline}
          disabled={disabled}
          InputProps={{ startAdornment, autoComplete: autocomplete, autoFocus: autofocus }}
          {...renderProps}
        />
      )}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/components/form/field-text.component.tsx